module.exports = __webpack_public_path__ + "static/media/s3-t.8bb01817.jpg";